var LayoutPerspective = require('./../layout/LayoutPerspective');
var patientSignupTemplate = require('./patientSignupTemplate.hbs');
var PatientSignupFormView = require('./PatientSignupFormView');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');

/**
 * Perspective to display the patient signup pages.
 *
 * @class PatientSignupPerspective
 * @constructor
 */
module.exports = LayoutPerspective.extend({
  moduleNamespace: 'patientSignupPerspective',
  template: patientSignupTemplate,

  behaviors: {
    portalPerspectiveLayoutBehavior: {
      behavior: PortalPerspectiveLayoutBehavior
    },
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: function() {
        if (this.inviteId) {
          return 'patient.signup.invite.aside.header';
        } else {
          return 'patient.signup.aside.header';
        }
      },
      asideContentMessageKey:  function() {
        if (this.inviteId) {
          return 'patient.signup.invite.aside';
        } else {
          return 'patient.signup.aside';
        }
      }
    }
  },

  injectionSites: {
    'sign-up': '_signupFormView'
  },

 /**
   * @method initialize
   * @param [options={}] {Object}
   *   @param [options.inviteId=undefined] {String} the invite id for the patient to signup.
   * @override
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    options = options || {};
    var inviteId = options.inviteId;
    this.getBehavior('asideBehavior').inviteId = inviteId;
    this._signupFormView = new PatientSignupFormView({inviteId: inviteId});
  }
});
